






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CollapsibleSection extends Vue {
  @Prop({ required: true }) expanded!: boolean
  @Prop({ required: false, default: '15rem' }) maxHeight!: string
  @Prop({ required: false, default: 'div' }) element!: string

  get calcMaxHeight () {
    return this.expanded ? this.maxHeight : '0rem'
  }

  get dynamicComponent () {
    return {
      template: `<${this.element}><slot/></${this.element}>`
    }
  }
}
